import React from 'react';
import './login.css';
import LoginImg from '../../images/LoginImg.png';

const Login = () => {
  const handleLogin = () => {
    // Send user to your backend’s SSO login endpoint
    window.location.href = `${window._env_.API_BASE_URL}/auth/login`;
  };

  // ✅ If already logged in, redirect directly
  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const redirectPath = sessionStorage.getItem('redirectAfterLogin') || '/Home';
      sessionStorage.removeItem('redirectAfterLogin');
      window.location.replace(redirectPath);
    }
  }, []);

  return (
    <div className="login-bg-container">
      <div className="login-card">
        <h2 className="login-platform">
          Learning <span className="login-accent">and Development</span>
        </h2>
        <h1 className="login-title">SSO LOGIN</h1>
        <p className="login-subtitle">
          Your journey to professional excellence starts here
        </p>
        <button className="login-microsoft-btn" onClick={handleLogin}>
          <svg
            className="login-microsoft-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <rect fill="#F35325" x="1" y="1" width="10" height="10" />
            <rect fill="#81BC06" x="13" y="1" width="10" height="10" />
            <rect fill="#05A6F0" x="1" y="13" width="10" height="10" />
            <rect fill="#FFBA08" x="13" y="13" width="10" height="10" />
          </svg>
          Login with Microsoft
        </button>
      </div>
      <img src={LoginImg} alt="Background" className="login-bg-img" />
      <div className="login-bg-overlay"></div>
    </div>
  );
};

export default Login;
